import { useEffect, useState } from "react";
import { AlertTriangle, ExternalLink, X } from "lucide-react";

const LIVE = process.env.REACT_APP_LIVE_URL;
const KEY = "mm_test_banner_hidden";

export const isTestSite = () => Boolean(LIVE) && window.location.origin !== new URL(LIVE).origin;

export const TestSiteBanner = () => {
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(KEY) === "1");
  const show = isTestSite() && !hidden;
  useEffect(() => {
    document.documentElement.style.setProperty("--mm-banner-h", show ? "44px" : "0px");
  }, [show]);
  if (!show) return null;
  const liveHref = LIVE.replace(/\/$/, "") + window.location.pathname;
  const hide = () => { sessionStorage.setItem(KEY, "1"); setHidden(true); };
  return (
    <div data-testid="test-site-banner" role="alert"
      className="sticky top-0 z-40 w-full min-h-[44px] bg-amber-400 text-amber-950 px-4 py-2 text-sm flex items-center gap-3">
      <AlertTriangle size={18} className="shrink-0" />
      <span className="flex-1 min-w-0">
        <strong>This is the TEST version.</strong> Your real data isn't here, and anything you save stays on this test copy.
      </span>
      <a href={liveHref} data-testid="test-site-banner-live-link"
        className="shrink-0 inline-flex items-center gap-1 rounded-full bg-amber-950 text-amber-50 px-3 py-1 font-semibold hover:opacity-90 transition-opacity">
        Open live app <ExternalLink size={14} />
      </a>
      <button type="button" onClick={hide} aria-label="Hide for now" data-testid="test-site-banner-hide"
        className="shrink-0 p-1 rounded-full hover:bg-amber-500 transition-colors">
        <X size={16} />
      </button>
    </div>
  );
};
